import React from "react";
import logo from "../Assets/Images/rb-line.svg";
import RB from "../Assets/Images/Ruby-Mine-Square.png";
import { HashLink as Link } from "react-router-hash-link";
import { BrowserRouter as Router } from "react-router-dom";

const Hero = () => {
  return (
    <Router>
      <div id="hero" className="hero-container">
        <div className="hero-logo-title-container">
          <div className="typewriter">
            <h1 data-aos="fade-down">
              The Most Intelligent Ruby and Rails IDE.
            </h1>
          </div>
          <img
            className="hero-logo"
            src={RB}
            alt="hero-logo"
            data-aos="fade-right"
          />
          <h1 className="hero-title" data-aos="fade-right" data-aos-delay="300">
            RubyMine
          </h1>
        </div>
        <Link
          to="#carousel"
          smooth
          className="hero-lets-start-btn"
          data-aos="fade-right"
          data-aos-delay="300"
        >
          Let's Start
        </Link>
        <img className="hero-img" src={logo} alt="hero-img-sidebar" />
      </div>
    </Router>
  );
};

export default Hero;
